import React from 'react';
export const THEMES = {
    appearances: {
        light: {
            colors: {
                background: '#FFF',
                muted: '#C7C7CC',
                separatorColor: '#C8C7CC',
                body: '#000',
                primary: '#007AFF',
                secondary: '#8E8E93',
            },
        },
        dark: {
            colors: {
                background: '#121312',
                muted: '#59595d',
                separatorColor: '#2b2b2d',
                body: '#FFF',
                primary: '#0f64ee',
                secondary: '#aeaeae',
            },
        },
    },
};
export const ThemeContext = React.createContext(THEMES.appearances.light);
//# sourceMappingURL=Theme.js.map